import { Color, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { VatDeclarationsReportPart } from '@features/vatDeclarations/types/vatDeclarationsReportPart'
import { VatDeclarationsReportSection as VatDeclarationsReportSectionType } from '@features/vatDeclarations/types/vatDeclarationsReportSection'

import { TableBody } from '../TableBody'
import * as Styled from './styles'

interface SectionProps {
  reportSegment: VatDeclarationsReportSectionType | VatDeclarationsReportPart
}

export const Section = ({ reportSegment }: SectionProps): ReactElement => {
  const renderReportSegments = useCallback(() => {
    if ('sections' in reportSegment) {
      return reportSegment.sections.map((reportSection) => <TableBody tableRowsData={reportSection.fields} />)
    } else if ('fields' in reportSegment) {
      return <TableBody tableRowsData={reportSegment.fields} />
    }
  }, [reportSegment])

  return (
    <>
      <thead>
        {reportSegment.name && (
          <Styled.HeadRow>
            <Styled.HeadCell colSpan={3}>
              <Text weight="bold" color={Color.White} variant="bodyLG">
                {reportSegment.name}
              </Text>
            </Styled.HeadCell>
          </Styled.HeadRow>
        )}
      </thead>
      <tbody>{renderReportSegments()}</tbody>
    </>
  )
}
